var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2609488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 17.25H1.5C1.30109 17.25 1.11032 17.171 0.96967 17.0303C0.829018 16.8897 0.75 16.6989 0.75 16.5C0.75 16.3011 0.829018 16.1103 0.96967 15.9697C1.11032 15.829 1.30109 15.75 1.5 15.75H22.5C22.6989 15.75 22.8897 15.829 23.0303 15.9697C23.171 16.1103 23.25 16.3011 23.25 16.5C23.25 16.6989 23.171 16.8897 23.0303 17.0303C22.8897 17.171 22.6989 17.25 22.5 17.25Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 9.75H1.5C1.30109 9.75 1.11032 9.67098 0.96967 9.53033C0.829018 9.38968 0.75 9.19891 0.75 9C0.75 8.80109 0.829018 8.61032 0.96967 8.46967C1.11032 8.32902 1.30109 8.25 1.5 8.25H22.5C22.6989 8.25 22.8897 8.32902 23.0303 8.46967C23.171 8.61032 23.25 8.80109 23.25 9C23.25 9.19891 23.171 9.38968 23.0303 9.53033C22.8897 9.67098 22.6989 9.75 22.5 9.75Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5 2.25H1.5C1.30109 2.25 1.11032 2.17098 0.96967 2.03033C0.829018 1.88968 0.75 1.69891 0.75 1.5C0.75 1.30109 0.829018 1.11032 0.96967 0.96967C1.11032 0.829018 1.30109 0.75 1.5 0.75H22.5C22.6989 0.75 22.8897 0.829018 23.0303 0.96967C23.171 1.11032 23.25 1.30109 23.25 1.5C23.25 1.69891 23.171 1.88968 23.0303 2.03033C22.8897 2.17098 22.6989 2.25 22.5 2.25Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.57d3e1e6b52a16a0ccc42ad6cd74f79f.svg";
export { ForwardRef as ReactComponent };